import { NAV_PATH } from '@/router/constants';
import { ConsultingContactProps } from './ConsultingContact';

export const ConsultingTab = {
	cate: '전문가 문의',
	title: '국내 최고 전문가와 함께하는 플랫폼'
};

type ExpertType = 'EXATYPE001' | 'EXATYPE002' | 'EXATYPE003' | 'EXATYPE004' | 'EXATYPE005' | 'EXATYPE006';

interface ConsultingTabData {
	title: string;
	desc: string;
	infoDesc: string[];
	focusList: string[];
	focusDetail: string[];
	attentionList: string[];
	contactUs: ConsultingContactProps['contactUs'];
}

export const ConsultingTabMap: Record<ExpertType, ConsultingTabData> = {
	EXATYPE001: {
		title: '세무',
		desc: '성장기업을 위한 세무자문 서비스',
		infoDesc: [
			'세무업무의 복잡성이 증대됨에 따라 회사는 각종 세무사항(법인세, 부가가치세, 원천세, 지방세 등) 에 대한 \n사전 검토 및 적시 세무자문에 대한 유인이 증가하고 있습니다.',
			'세무이슈에 대한 사전 검토를 통하여 회사의 세무리스크 파악 및 합법적 해결/ 관리방안 모색이 가능하며, \n세법 취지 등을 고려한 세무정책 수립을 지원할 수 있습니다.'
		],
		focusList: [
			'법인 관련 법인세, 부가가치세, 조특법, 국제조세 적용',
			'법인과의 거래와 관련된 상속세 및 증여세, 소득세 등의 적용',
			'기타 제세 검토 (국세기본법, 지방세법 등)'
		],
		focusDetail: [
			'세무상 과세거래 여부 판단 및 제반신고 납부 절차 검토',
			'거래 관련 세무이슈 검토 (i.e. 특수관계자간 거래, 매입세액 공제 여부, 세액공제 감면 적용 등)',
			'기업구조조정(합병, 분할, 사업양수도 등) 관련 세무이슈 검토'
		],
		attentionList: [
			'본 서비스를 이용한 답변제공 시 귀사가 기재한 사실관계에 기반하여 신뢰할만한 전문가에 의해 상담서비스가 제공되나 최종 의사결정은 전적으로 귀사의 책임이며, 그 어떤 경우에도 법적 책임소재에 대한 증빙자료로 사용될 수 없습니다.',
			'본 서비스를 이용한 답변은 권한있는 기관(법원, 과세관청)의 유권해석과 차이가 있을 수 있으므로 참고자료로만 활용하시기 바랍니다. 의사결정 등 실제 적용에 있어서는 공식적으로 권한 있는 기관이나 해당 분야 전문가의 조언을 얻어 충분히 검토하시기 바라며, 폐 법인은 본 자문의 내용을 활용함으로서 인해 발생되는 결과에 법적 책임 등이 없음을 유의하시기 바랍니다. ',
			'본 서비스를 이용 시, 세액의 계산이나 유료로 제공되는 자문 수준의 서비스 (예시)는 제공하지 않는다는 점을 양지하여 주시기 바랍니다. (예시: 사실관계에 대한 전반적인 세무리스크 질의, 간단한 질의가 아닌 2~3가지의 질문사항을 한번에 질의하는 경우, 하나의 질의에 회계처리 및 세무조정과 부가세 등 여러가지 분야에 대한 상담을 한번에 질의하는 경우, 양도소득세/상속 및 증여세 관련하여 상황별 절세 방안 등의 질의 등)',
			'보다 정확한 사실관계 및 답변을 필요로 하는 상담 및 자문 건에 대하여는 별도의 계약이 필요할 수 있습니다.'
		],
		contactUs: [
			{
				name: '이민지',
				duty: '회계사',
				desc: '삼일회계법인 20년 근무, 법인조세 전문'
			}
		]
	},
	EXATYPE002: {
		title: '결산',
		desc: '통합경영지원서비스 및 회계자문 서비스',
		infoDesc: [
			'많은 스타트업 기업들이 성장단계에 접어들면서 조직 및 인력의 운용, 재무 및 Compliance 준수 등 \n경영관리 범위가 확대되지만, 적절한 인원 수급의 어려움, 인력 운영 등 비효율성 측면에서 충분한 서비스를 \n적시에 제공받지 못하고 있습니다. ',
			'통합경영지원서비스는 기업운영의 효율성을 위한 아웃소싱 서비스와 상장, 투자유치 자문 등 \n기업의 성장을 위한 자문 서비스로 구성되어 있습니다.'
		],
		focusList: [
			'결산 / 감사 및 실사 대응 관련 자문',
			'결산 시스템 및 경영관리 보고체계 구축',
			'경영관리 및 조직관리 자문',
			'일반 회계자문 서비스',
			'K-IFRS 전환 지원 및 사전 효과 검토',
			'내부회계관리제도 구축 및 운영 지원'
		],
		focusDetail: [
			'결산 / 감사 / 실사 대응 업무 : 주요 계정과목 별 결산 지원, 재무제표 및 주석 작성 지원, 감사 & 실사 준비 및 이슈 대응 지원',
			'결산 시스템 및 경영관리 보고체계 구축 : 수작업 업무 자동화 전환, 개인별 BI Report 구축, 시스템을 통한 결산 환경 구축 지원',
			'일반 회계자문 서비스 : 특정 거래 관련 회계처리 영향 분석 및 기준서 검토',
			'K-IFRS 전환 지원 및 사전 효과 검토 : 상장준비를 위한 K-IFRS 전환 및 K-IFRS 전환시 효과에 대한 예비적 검토 지원 ',
			'내부회계관리제도 구축 및 운영 지원 : 상장준비를 위한 내부회계관리제도 구축 및 To-be Process 수립, 운영단계 평가 업무에 대한 아웃소싱 서비스 지원'
		],
		attentionList: [
			'본 서비스를 이용한 답변제공 시 귀사가 기재한 사실관계에 기반하여 회계기준서에 근거하여 신뢰할만한 전문가에 의해 제공되나 최종 의사결정은 전적으로 귀사의 책임이며, 그 어떤 경우에도 법적 책임소재에 대한 증빙자료로 사용될 수 없습니다.',
			'본 서비스를 이용한 답변은 권한있는 기관의 유권해석과 차이가 있을 수 있으므로 참고자료로만 활용하시기 바랍니다. 의사결정 등 실제 적용에 있어서는 공식적으로 권한 있는 기관이나 해당 분야 전문가의 조언을 얻어 충분히 검토하시기 바라며, 폐 법인은 본 자문의 내용을 활용함으로서 인해 발생되는 결과에 법적 책임 등이 없음을 유의하시기 바랍니다. ',
			'보다 정확한 사실관계 및 답변을 필요로 하는 상담 및 자문 건에 대하여는 별도의 계약이 필요할 수 있습니다.'
		],
		contactUs: [
			{
				name: '조윤환',
				duty: 'Director | 공인회계사',
				desc: '삼일회계법인 AX Node \n스텔라 개발담당 및 스타트업 통합경영지원서비스 담당 \nTel. 02-709-8228 \nyun-hwan.cho@pwc.com'
			},
			{
				name: '최세리',
				duty: 'Manager | 공인회계사',
				desc: '삼일회계법인 AX Node \n스텔라 개발담당 및 스타트업 통합경영지원서비스 담당 \nTel. 02-3781-2585 \nseri.choi@pwc.com'
			}
		]
	},
	EXATYPE003: {
		title: '법무',
		desc: '스타트업 법률 경영지원서비스',
		infoDesc: [
			'스타트업은 새로운 가능성에 도전하는 만큼, 불확실성과 법률 리스크에도 끊임없이 직면합니다. \n기업의 중요한 의사결정에는 언제나 법률적 고려가 뒤따라야 경영의 안정성과 성장 기회를 잡을 수 있습니다. \n법무법인 별의 ‘법률 경영지원 서비스’는 스타트업이 지속가능한 성장을 이어갈 수 있도록 실질적이고 선제적인 법률 자문을 제공합니다. \n설립부터 Exit까지, 법무법인 별은 스타트업의 여정을 함께하는 든든한 법률 파트너 입니다.'
		],
		focusList: [
			'기업 운영제도 및 법률 리스크 예방 자문',
			'투자 자문',
			'M&A 자문',
			'지분 및 주주관리',
			'스톡옵션 및 임직원 인센티브 제도 설계',
			'계약·분쟁 대응 및 소송 지원'
		],
		focusDetail: [
			'정관 개정, 의사결정 구조 설계, 내부 규정 수립 등 기업 운영의 투명성과 안정성을 위한 법률 자문',
			'투자(Seed, Pre A, Series A-Pre IPO) 계약서 검토, 투자계약 전후 필요한 자문 및 등기',
			'인수합병(M&A) 관련하여 거래구조 검토, 계약서 검토, 조건 협상, 실사 대응, 구조 설계 등 핵심 절차 전반을 자문',
			'공동창업자 간 계약, 주주 간 협약, 지분 분쟁 예방 등 신뢰 기반의 지배구조 유지를 지원',
			'핵심 인재 확보와 유지를 위한 스톡옵션 제도 및 인센티브 설계',
			'각종 계약서 작성·검토부터 분쟁 발생 시 조정, 대응, 소송 수행까지 종합적인 법률 지원'
		],
		attentionList: [
			'본 서비스를 이용한 답변제공 시 귀사가 기재한 사실관계에 기반하여 신뢰할만한 전문가에 의해 상담서비스가 제공되나 최종 의사결정은 전적으로 귀사의 책임이며, 그 어떤 경우에도 법적 책임소재에 대한 증빙자료로 사용될 수 없습니다.',
			'본 서비스를 이용한 답변은 권한있는 기관의 유권해석과 차이가 있을 수 있으므로 참고자료로만 활용하시기 바랍니다. 의사결정 등 실제 적용에 있어서는 공식적으로 권한 있는 기관이나 해당 분야 전문가의 조언을 얻어 충분히 검토하시기 바라며, 폐 법인은 본 자문의 내용을 활용함으로서 인해 발생되는 결과에 법적 책임 등이 없음을 유의하시기 바랍니다. ',
			'보다 정확한 사실관계 및 답변을 필요로 하는 상담 및 자문 건에 대하여는 별도의 계약이 필요할 수 있습니다.'
		],
		contactUs: [
			{
				name: '강혜미',
				duty: '변호사',
				desc: '법무법인 별 대표변호사, 대한변호사협회 스타트업/M&A 전문분야 등록'
			},
			{
				name: '원우진',
				duty: '변호사',
				desc: '법무법인 별 파트너변호사, 스타트업 자문 100건 이상'
			},
			{
				name: '법무법인 별 contact 팀',
				duty: '',
				desc: 'contact@star-law.kr'
			}
		]
	},
	EXATYPE004: {
		title: 'IP관리',
		desc: '지식재산 컨설팅(특허, 상표, 디자인 등)',
		infoDesc: [
			'기술혁신과 디지털 전환이 가속화되면서, 기업의 경쟁력은 보유한 지식재산의 가치와 \n이를 전략적으로 활용하는 역량에 의해 좌우되고 있습니다. \n특히 산업의 고도화에 따라 특허·상표·디자인 등 무형자산의 체계적인 확보와 보호, 수익화 전략, 분쟁 대응, \n포트폴리오 재구성, 기술가치평가 등 지식재산 기반 경영이 필수화되고 있습니다. \n에이앤케이(AnK) 특허법률사무소는 탑티어 로펌에서의 10년 이상의 실무 경험과 다양한 산업에 대한 \n깊은 이해를 바탕으로 지식재산의 전주기적 관리와 전략 수립에 대한 최적의 솔루션을 제공합니다.'
		],
		focusList: [
			'특허, 상표, 디자인, 실용신안, 저작권 등',
			'출원, 심판, 소송',
			'출원 전략, IP Portfolio 설계전략, IP R&D, IP Landscape, 기술가치평가',
			'자문, 분쟁업무'
		],
		focusDetail: [
			'특허, 상표, 디자인, 실용신안, 저작권 등: 무형자산을 다양한 방식으로 보호하고, 전략적 권리화를 통해 기업의 경쟁우위를 확보할 수 있도록 지원합니다.',
			'출원, 심판, 소송: 국내외 권리 확보를 위한 출원부터, 무효심판, 권리범위확인심판, 이의신청 등 각종 절차, 나아가 특허 및 상표 관련 민·형사 소송에 이르기까지 분쟁 전주기에 걸친 통합 서비스를 제공합니다.',
			'출원 전략, IP Portfolio 설계전략, IP R&D, IP Landscape, 기술가치평가: 기술/시장 분석을 기반으로 한 최적의 출원 전략을 수립하고, 기업의 사업방향과 연계된 지식재산 포트폴리오 설계, 그리고 기술가치평가까지 지원합니다. 또한, 기술개발 단계에서부터 IP 요소를 반영하는 IP-R&D 전략, 산업/기술/시장 중심의 IP Landscape 검토를 통해 지식재산이 실제 사업 성과로 이어지도록 체계적으로 관리합니다.',
			'자문, 분쟁업무: 국내외 IP 관련 법률·제도에 대한 해석 및 적용, 권리침해 여부 검토, 계약 및 라이선싱 자문, 기술이전 및 공동연구 관련 IP 분쟁 예방 전략 등 다각적인 자문 서비스를 제공합니다. 또한 실제 분쟁 발생 시에는 침해 분석, 증거 확보, 협상, 소송 등의 대응까지 전문적으로 수행합니다.'
		],
		attentionList: [
			'본 서비스를 이용한 답변제공 시 귀사가 기재한 사실관계에 기반하여 신뢰할만한 전문가에 의해 상담서비스가 제공되나 최종 의사결정은 전적으로 귀사의 책임이며, 그 어떤 경우에도 법적 책임소재에 대한 증빙자료로 사용될 수 없습니다.',
			'본 서비스를 이용한 답변은 권한있는 기관의 유권해석과 차이가 있을 수 있으므로 참고자료로만 활용하시기 바랍니다. 의사결정 등 실제 적용에 있어서는 공식적으로 권한 있는 기관이나 해당 분야 전문가의 조언을 얻어 충분히 검토하시기 바라며, 폐 법인은 본 자문의 내용을 활용함으로서 인해 발생되는 결과에 법적 책임 등이 없음을 유의하시기 바랍니다. ',
			'보다 정확한 사실관계 및 답변을 필요로 하는 상담 및 자문 건에 대하여는 별도의 계약이 필요할 수 있습니다.'
		],
		contactUs: [
			{
				name: '김세환',
				duty: '변리사',
				desc: '김·장 법률사무소 10년 근무, \n미국·일본 로펌 근무 경험, IP Total 서비스 제공'
			}
		]
	},
	EXATYPE005: {
		title: '노무',
		desc: '스타트업 노무 지원서비스',
		infoDesc: [
			'현대 사회는 급격한 변화와 함께 다양한 산업 환경을 경험하고 있으며, 이러한 변화는 노동 시장과 \n인사 노무 측면에 큰 영향을 미치고 있습니다. 또한, 중대재해처벌법 시행으로 인해 산업안전과 중대재해 예방의 \n중요성이 더욱 강조되고 있습니다.',
			'STELLA의 노무 지원 서비스는 이러한 변화에 발맞추어 인사/노무 분야에서 요구되는 사항에 \n최적화된 해결책과 서비스를 제시하고 있습니다.'
		],
		focusList: [
			'근로계약서 및 규정 정비 ',
			'노무 자문',
			'payroll',
			'노동부/노동위원회 사건 대리',
			'직장 내 성희롱/괴롭힘 조사',
			'법정필수의무교육 및 노무 교육',
			'산업안전/중대재해 대응 컨설팅',
			'일터혁신 컨설팅'
		],
		focusDetail: [
			'근로계약서 및 규정 정비: 다양한 고용형태 및 근무형태에 맞춘 근로계약서 작성 및 상시근로자수별 필수 규정 설계 및 지원',
			'노무 자문: 합리적이고 적법한 인사/조직 관리를 할 수 있도록 지원하고, 기업 운영과정에서 발생하는 노무 Risk를 사전에 예방할 수 있도록 지원',
			'payroll: 사업장 급여 관리와 노무서비스를 연계하여 지원하고, 4대보험 취득, 상실신고 등 대행, 지원금 신청',
			'노동부/노동위원회 사건 대리: 부당해고 등 구제신청 사건, 진정∙고소 사건 등 대리를 통해 효과적인 대응 및 해결 지원',
			'직장 내 성희롱/괴롭힘 조사: 직장 내 괴롭힘, 성희롱 사건 발생 시 조사 및 조사보고서 작성, 이후 대응방향 제언',
			'법정필수의무교육 및 노무 교육: 필수 법정필수의무교육을 통한 노동법 compliance 및 노무 교육을 통한 노무관리 실무역량/갈등관리/소통역량 향상 지원',
			'산업안전/중대재해 대응 컨설팅: 안전보건관리체계 구축을 요구하는 산업안전보건법/중대재해처벌법 준수를 위한 사업장 현황별 맟춤형 대응시스템 구축',
			'일터혁신 컨설팅: 전액 정부지원을 통해 사업장 상황에 맞는 맞춤형 해결책 제시하여 기업의 자체적 혁신 지원"'
		],
		attentionList: [
			'본 서비스를 이용한 답변제공 시 귀사가 기재한 사실관계에 기반하여 신뢰할만한 전문가에 의해 상담서비스가 제공되나 최종 의사결정은 전적으로 귀사의 책임이며, 그 어떤 경우에도 법적 책임소재에 대한 증빙자료로 사용될 수 없습니다.',
			'본 서비스를 이용한 답변은 권한있는 기관의 유권해석과 차이가 있을 수 있으므로 참고자료로만 활용하시기 바랍니다. 의사결정 등 실제 적용에 있어서는 공식적으로 권한 있는 기관이나 해당 분야 전문가의 조언을 얻어 충분히 검토하시기 바라며, 폐 법인은 본 자문의 내용을 활용함으로서 인해 발생되는 결과에 법적 책임 등이 없음을 유의하시기 바랍니다. ',
			'보다 정확한 사실관계 및 답변을 필요로 하는 상담 및 자문 건에 대하여는 별도의 계약이 필요할 수 있습니다.'
		],
		contactUs: [
			{
				name: '오다빈',
				duty: '노무사',
				desc: '노무법인 더원컨설팅그룹 공인노무사(경력 9년)'
			}
		]
	},
	EXATYPE006: {
		title: '기술평가/기술특례상장',
		desc: '기술특례상장 컨설팅/기술가치평가',
		infoDesc: [
			'기술특례상장은 단순한 기술력 검증을 넘어, 기업의 사업성, 시장성, 지속가능성까지 \n복합적으로 입증해야 하는 고난도의 절차입니다. 평가기관별로 중점 평가 항목이 상이하고, \n기대 수준 또한 높아지고 있어, 내부 역량만으로는 효과적인 대응이 쉽지 않습니다. \n따라서, 기술특례상장 컨설팅은 체계적인 평가 대응 전략 수립과 자료 설득력 제고를 통해 \n성공 가능성을 높이는 필수적인 지원 수단입니다. ',
			'NICE평가정보㈜ 는 국내 최고의 기술평가 역량과 상장 컨설팅 경험으로 귀사의 성공적인 코스닥 입성과 \n미래를 앞당기고자 합니다.'
		],
		focusList: [
			'기술특례상장 컨설팅',
			'기술(IP) 가치평가',
			'투자용 기술평가',
			'정부과제 제출용 기술평가',
			'기술시장분석 / 기술실사 등'
		],
		focusDetail: [
			'기술특례상장 준비를 위한 컨설팅(모의평가, 차이분석, 사업계획서 리뷰 등)',
			"기술이전, 투자유치, 현물출자 등을 위한 '기술(IP)'의 가치금액 산출을 위한 평가",
			'TCB펀드의 주목적 투자대상 선정 또는 VC 등으로부터 투자유치를 위한 평가 ',
			'산자부, 중기부 과제 선정 시 필요한 기술평가',
			'신사업 추진/M&A 근거 마련을 위한 분석'
		],
		attentionList: [
			'본 서비스를 이용한 답변제공 시 귀사가 기재한 사실관계에 기반하여 신뢰할만한 전문가에 의해 상담서비스가 제공되나 최종 의사결정은 전적으로 귀사의 책임이며, 그 어떤 경우에도 법적 책임소재에 대한 증빙자료로 사용될 수 없습니다.',
			'본 서비스를 이용한 답변은 권한있는 기관의 유권해석과 차이가 있을 수 있으므로 참고자료로만 활용하시기 바랍니다. 의사결정 등 실제 적용에 있어서는 공식적으로 권한 있는 기관이나 해당 분야 전문가의 조언을 얻어 충분히 검토하시기 바라며, 폐 법인은 본 자문의 내용을 활용함으로서 인해 발생되는 결과에 법적 책임 등이 없음을 유의하시기 바랍니다. ',
			'보다 정확한 사실관계 및 답변을 필요로 하는 상담 및 자문 건에 대하여는 별도의 계약이 필요할 수 있습니다.'
		],
		contactUs: [
			{
				name: '임희훈',
				duty: '매니저',
				desc: 'NICE평가정보 12년 근무, 기술평가/기술특례상장 전문'
			},
			{
				name: '이홍탁',
				duty: '매니저',
				desc: 'NICE평가정보 10년 근무, 기술평가/기술특례상장 전문'
			}
		]
	}
};
